import { Sentry } from 'lib/sentry'

function logout() {
    Sentry.unsetUser()
}

export const App = {
    logout,
}
